<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-public-subscription-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>

<p-drawer
  [customCloseEvent]="customBillingAddressEditDialogCloseEvent"
  [visible]="billingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>
      Edycja adresu rozliczeniowego subskrypcji
    </app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedSubscriptionNumber(); as selectedSubscriptionNumber) {
        <app-public-subscription-billing-address-edit
          (cancelEvent)="handleBillingAddressCancelEvent()"
          (submitEvent)="handleBillingAddressSubmitEvent()"
          [number]="selectedSubscriptionNumber" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customEditDialogCloseEvent"
  [visible]="subscriptionEditVisibility()"
  appDrawerSidebar
  position="right"
  size="lg">
  <ng-template #header>
    <app-drawer-title>Edycja subskrypcji</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedSubscriptionNumber(); as selectedSubscriptionNumber) {
        <app-public-subscription-edit
          [number]="selectedSubscriptionNumber"
          (cancelEvent)="handleSubscriptionEditCancelEvent()"
          (submitEvent)="handleSubscriptionEditSubmitEvent()" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customShippingAddressEditDialogCloseEvent"
  [visible]="shippingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Edycja adresu dostawy subskrypcji</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedSubscriptionNumber(); as selectedSubscriptionNumber) {
        <app-public-subscription-shipping-address-edit
          (cancelEvent)="handleShippingAddressCancelEvent()"
          (submitEvent)="handleShippingAddressSubmitEvent()"
          [number]="selectedSubscriptionNumber" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>
